import React, { useEffect } from 'react';

const SANS = "'Plus Jakarta Sans',sans-serif";

const OPTIONS = [
  {
    id: 'log',
    title: 'Log entry',
    sub: 'Sail, race, or time aboard at anchor or dock',
    color: 'var(--navy)',
    icon: <><path d="M3 17l9-13 9 13"/><path d="M3 17c0 2.5 18 2.5 18 0"/><line x1="12" y1="4" x2="12" y2="17"/></>,
  },
  {
    id: 'fuel',
    title: 'Fuel entry',
    sub: 'Log a fill, gallons, price, and engine hours',
    color: 'var(--gold)',
    icon: <><path d="M4 20V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v15"/><line x1="3" y1="20" x2="15" y2="20"/><path d="M14 9h3a2 2 0 0 1 2 2v6a1.5 1.5 0 0 0 3 0v-8l-3-3"/><line x1="7" y1="8" x2="11" y2="8"/></>,
  },
  {
    id: 'maintenance',
    title: 'Maintenance',
    sub: 'Systems check or a service record',
    color: 'var(--slate)',
    icon: <><path d="M14.7 6.3a4 4 0 0 0 5 5l-9.4 9.4a2.1 2.1 0 0 1-3-3l9.4-9.4z"/><circle cx="17.5" cy="6.5" r="3.2"/></>,
  },
];

export default function AddSheet({ isOpen, onClose, onPick }) {
  useEffect(() => {
    if (!isOpen) return;
    const esc = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', esc);
    return () => window.removeEventListener('keydown', esc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      onClick={onClose}
      style={{
        position:'fixed', inset:0, zIndex:4000, background:'rgba(11,22,38,.34)',
        backdropFilter:'blur(2px)', display:'flex', alignItems:'flex-end', justifyContent:'center',
        padding:16, paddingBottom:'calc(16px + env(safe-area-inset-bottom))',
      }}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{
          width:'100%', maxWidth:440, background:'var(--surface)', borderRadius:18, padding:8,
          boxShadow:'0 1px 2px rgba(11,22,38,.04), 0 18px 44px rgba(11,22,38,.24)',
        }}
      >
        <div style={{ fontFamily:SANS, fontSize:12, fontWeight:600, letterSpacing:'.09em', textTransform:'uppercase', color:'var(--slate)', padding:'12px 12px 8px' }}>
          What are you logging?
        </div>

        {OPTIONS.map((o, i) => (
          <div
            key={o.id}
            onClick={() => { onPick(o.id); onClose(); }}
            style={{
              display:'flex', alignItems:'center', gap:13, padding:'13px 12px', cursor:'pointer',
              borderTop: i ? '1px solid var(--hair, #E7E1D5)' : 'none',
            }}
          >
            <span style={{ flex:'0 0 38px', width:38, height:38, borderRadius:11, background:'var(--tint, #FAF8F4)', display:'flex', alignItems:'center', justifyContent:'center', color:o.color }}>
              <svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">{o.icon}</svg>
            </span>
            <span style={{ minWidth:0 }}>
              <div style={{ fontFamily:SANS, fontSize:15, fontWeight:600, color:'var(--navy)' }}>{o.title}</div>
              <div style={{ fontFamily:SANS, fontSize:12, color:'var(--slate)', marginTop:2 }}>{o.sub}</div>
            </span>
            <span style={{ marginLeft:'auto', color:'var(--slate)', fontSize:18 }}>›</span>
          </div>
        ))}

        <button
          onClick={onClose}
          style={{ width:'100%', marginTop:8, background:'var(--tint, #FAF8F4)', border:'none', borderRadius:12, padding:13, fontFamily:SANS, fontSize:13, fontWeight:600, color:'var(--slate)', cursor:'pointer' }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
